import { render } from "./CIS-CTA-Carousel-Item.vue?vue&type=template&id=19082982&scoped=true"
import script from "./CIS-CTA-Carousel-Item.vue?vue&type=script&lang=js"
export * from "./CIS-CTA-Carousel-Item.vue?vue&type=script&lang=js"

import "./CIS-CTA-Carousel-Item.vue?vue&type=style&index=0&id=19082982&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19082982"]])

export default __exports__